export class UnifiedRestoreEntityMicrosoft365 {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "exchange",
            "baseName": "exchange",
            "type": "UnifiedRestoreWorkload",
            "format": ""
        },
        {
            "name": "oneDrive",
            "baseName": "oneDrive",
            "type": "UnifiedRestoreWorkload",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedRestoreEntityMicrosoft365.attributeTypeMap;
    }
    constructor() {
    }
}
